const React = require('react');
const PropTypes = require('prop-types');
require('./RiskDial.scss');

const RiskDial = ({ index }) => (
    <div className="risk-indicator__risk-dial">
        <div
            className="risk-indicator__risk-dial__line"
            style={{ width: (index - 1) * 42 }}
        />
    </div>
);

RiskDial.propTypes = {
    index: PropTypes.number.isRequired,
};

module.exports = RiskDial;
